<template>
<div class="ranking-page">
<nav class="global-nav" role="navigation">
  <ul>
    <li>
      <router-link class="button dayrace-button" :to="{name:'Index'}">トップ</router-link>
    </li>
  </ul>
</nav>
<nav class="bread-nav" aria-label="You are here:" role="navigation">
  <ul class="breadcrumbs">
    <li><router-link :to="{name:'Index'}">Top</router-link></li>
    <li>
      獲得賞金ランキング 
    </li>
    <li>
      <span class="show-for-sr">Current: </span> {{ kbn_name }}
    </li>
  </ul>
</nav>
<div class="ranking-wrapper">
<h1 class="ranking-title">獲得賞金ランキング {{ kbn_name }}</h1>
<ul class="tabs ranking-contents-tabs">
<li class="tabs-title" :class="kbn=='all' ? 'is-active':''"><router-link :to="{name:'RacerRanking',params:{kbn:'all'}}">総合</router-link></li>
<li class="tabs-title" :class="kbn=='danshi' ? 'is-active':''"><router-link :to="{name:'RacerRanking',params:{kbn:'danshi'}}">男子</router-link></li>
<li class="tabs-title" :class="kbn=='jyoshi' ? 'is-active':''"><router-link :to="{name:'RacerRanking',params:{kbn:'jyoshi'}}">女子</router-link></li>
</ul>  
<div class="term">{{ term }}</div>

<table v-if="racer_details.length > 0">
<thead>
  <tr>
  <th class="rank">順位</th>
  <th></th>
  <th class="sensyu-name">選手名<br />登番</th>
  <th class="sibu">支部</th>
  <th class="kyu">級別</th>
  <th class="prize">獲得賞金額</th>
  </tr>
</thead>
<tbody>
  <tr v-for="racer_detail in racerDetailKeys" :key="racer_detail.toban" >
    <td class="rank">
      <span class="rank-num">{{ racer_detail.rank }}</span>
    </td>
    <td class="photo">
       <router-link :to="{name:'RacerProfile',params:{toban:racer_detail.toban,tabname:'kibetsu'}}">
      <span class="racer-photo-wrapper"><img :src= "RACER_PHOTO_BASE_URL + racer_detail.toban+'.jpg'" class="racer-photo"  loading="lazy" alt="" /></span>
       </router-link>
    </td>
    <td class="sensyu-name">
      <router-link :to="{name:'RacerProfile',params:{toban:racer_detail.toban,tabname:'kibetsu'}}">
      <span class="name">{{ racer_detail.name }}</span><br />
      <span class="toban">{{ racer_detail.toban }}</span>
      </router-link>
    </td>
    <td class="sibu">
       {{ racer_detail.sibu }}
    </td>
    <td class="kyu">
      {{ racer_detail.kyu }}
    </td>
    <td class="prize">
     ¥{{ Number(racer_detail.syokin).toLocaleString() }} 
    </td>
  </tr>
</tbody>
</table>
</div>
</div>

</template>
<script>
import API_BASE_URL  from '../mixins/PrefsMixin'
import pianoSend from '../mixins/PrefsMixin'
// 👇 ブラウザ向け ESM 版を使う（Buffer 不要）
import { parse } from 'csv-parse/browser/esm/sync'

export default {
  mixins: [API_BASE_URL, pianoSend],
  name: 'RacerRanking',

  data () {
    return {
      ranking: [],
      term: '',
      kbn: 'all',
      kbn_name: '',
      racer_details: []
    }
  },

  head () {
    return {
      title () {
        return {
          inner: '賞金ランキング',
          separator: ' - ',
          complement: 'BOATNAVI報知'
        }
      }
    }
  },

  computed: {
    racerDetailKeys () {
      return this.racer_details.filter(item => item.toban !== null)
    }
  },

  created () {
    this.kbn = this.$route.params['kbn']
    this.kbn_name = {
      all: '全選手',
      danshi: '男子',
      jyoshi: '女子'
    }[this.kbn]

    this.getData()
  },

  beforeRouteUpdate (_to, _from, next) {
    if (_to.name === 'RacerRanking' && this.kbn !== _to.params['kbn']) {
      this.kbn = _to.params['kbn']
      this.term = ''
      this.kbn_name = {
        all: '全選手',
        danshi: '男子',
        jyoshi: '女子'
      }[this.kbn]
      this.ranking = []
      this.racer_details = []
      this.getData()
    }
    next()
  },

  methods: {
    async getData () {
      const loader = this.$loading.show({})

      try {
        // ▼ CSV ファイル名（キャッシュバスター付き）
        const ts = Math.floor(Number(Date.now()) / 1000 / 60)
        const name = this.kbn === 'danshi'
          ? 'danshi.csv'
          : this.kbn === 'jyoshi'
            ? 'jyoshi.csv'
            : this.kbn === 'all'
              ? 'all.csv'
              : null

        if (!name) {
          loader.hide()
          return this.$router.replace({ name: 'NotFound' })
        }

        const url = `/ranking_data/${name}?ts=${ts}`

        // ▼ CSV を Blob で取得して Shift_JIS で文字列化（Buffer も iconv-lite も不要）
        const res = await this.axios.get(url, { responseType: 'blob' })
        const body = await this.blobToText(res.data, 'shift_jis') // 'shift_jis' / 'ms932' どちらでも可

        // ▼ 3行目の1列目をそのまま期間文言として使用
        this.term = parse(body, { columns: false, from_line: 3, to_line: 3 })[0][0]

        // ▼ 4行目以降をデータとしてパース（ヘッダーあり）
        this.ranking = parse(body, { columns: true, from_line: 4 })

        // ▼ 各選手の詳細を非同期で収集
        await Promise.all(
          this.ranking.map((r) => this.getRacerDetail(r['登録番号'], r['順位'], r['獲得賞金額']))
        )
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.$router.replace({ name: 'NotFound' })
      } finally {
        loader.hide()
      }
    },

    // Blob → 指定エンコーディングで string
    blobToText (blob, encoding = 'utf-8') {
      return new Promise((resolve, reject) => {
        const fr = new FileReader()
        fr.onerror = () => reject(fr.error)
        fr.onload = () => resolve(String(fr.result || ''))
        // 第二引数のエンコードで Shift_JIS を指定
        fr.readAsText(blob, encoding)
      })
    },

    async getRacerDetail (toban, rank, syokin) {
      try {
        const { data } = await this.axios.get(`${this.API_BASE_URL}racer_profile/${toban}`)
        const detail = { rank, syokin, ...data.profile }
        // 順位は 1 始まりなので index は rank-1
        this.$set(this.racer_details, Number(rank) - 1, detail)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('getRacerDetail failed for', toban, e)
      }
    }
  }
}
</script>

<style scoped>
.ranking-title{
  margin-left:10px;
}

.ranking-contents-tabs .tabs-title a{
  background-color:rgb(204, 228, 241);
  color:#333;
}


.ranking-contents-tabs .tabs-title.is-active{
  background-color:rgb(108 135 176);
}
.ranking-contents-tabs .tabs-title a:hover{
  background-color:rgb(218, 237, 248);
}

.ranking-contents-tabs .tabs-title.is-active a{
  color:#FFF;
  font-weight: bold;
  background-color:#003049;
}
.ranking-contents-tabs .tabs-title.is-active a:hover{
  color:#FFF;
  background-color:#003049;
}

.rank{
  text-align:center;
  width:32px;
}

.rank .rank-num{
  display:inline-block;
  width:32px;
  height:32px;
  line-height:32px;
  background-color: rgb(182, 179, 179);
  color: #000;
}
.sibu{
  text-align:center;
}
.kyu{
  text-align:center;
}
.prize{
  text-align:right;
  padding-right:10px;
}

.sensyu-name .name{
  font-weight:bold;
}

tbody tr:nth-child(-n + 10) td.rank .rank-num{
  background-color:#FF0000;
  color: #FFF;
  font-weight:bold; 
}

tbody tr:nth-child(n + 11) td.rank .rank-num{
  background-color:#ff9900;
  color: #FFF;
  font-weight:bold; 
}

tbody tr:nth-child(n + 21) td.rank .rank-num{
  background-color: rgb(182, 179, 179);
  color: #000;
  font-weight:normal;
}
.photo{
  width:64px;
}

.racer-photo-wrapper{
  width:64px;
  height:64px;
  display:block;
  position: relative;
  overflow:hidden;
}

.term{
  font-size:14px;
  margin:10px;
}

@media screen and (max-width:375px) { 
  .racer-photo-wrapper{
    width:40px;
    height:40px;
  }
.photo{
  width:48px;
}
  .racer-photo{
    width:100%;
    display:block;
    position: absolute;
  }
}
</style>